import BaseClass from "./BaseClass";
import Helper from "./Helper";
import cardCheck from "./cardCheck";

const defaultOptions = {};

export default class Reservation extends BaseClass {
  /**
   * Constructor
   *
   * @param options
   */
    constructor(options)
    {
        super(options, defaultOptions);
        this.removeWrapperCount = 1;
        this.radioButtonClicked = false;

        this.init();
    }

    init()
    {
        $(document).ready(() => {
            window.radioButtonClicked = false;

            if (
                $("#reservation_reservation-detail [data-modal-to-body]").length > 0
            ) {
                $("#reservation_reservation-detail [data-modal-to-body]").appendTo(
                    "body"
                );
                Helper.initModals(
                  "#reservation_reservation-detail",
                  "[data-rooms-scroll]",
                  "mouseover"
                );
            }

            $('input[name="agree_conditions"]').click((event) => {
                if ($("button[name='cancel_reservation']").length > 0) {
                    $("button[name='cancel_reservation']").first()[0].disabled = false;
                } else {
                    this.radioButtonClicked = true;
                    this.checkFilledInputs();
                }
            });

            Reservation.inputRequiredCheck();
            window.addEventListener("resize", Reservation.inputRequiredCheck());

        let dim = $('[data-dim="cancelled-reservation"]');

            if ($(dim).length > 0 && $(dim).hasClass('active')) {
                $('body').css('overflow', 'hidden');

                $(dim).click(()  => {
                    Reservation.handleDimClick(dim);
                  })

                $('[data-reservationCancelled]').click(() => {
                    Reservation.handleDimClick(dim);
                  })
            }

            if ($('[data-fillbookingdata]').length > 0) {
                let language = document.documentElement.lang;
                let select =  $('select[name="country"]');
                language = language === 'en' ? 'gb' : language;

                let countryValue = $(select).find(`option[data-code="${language}"]`).val();
                $(select).val(countryValue ?? 0);
            }
        });
    }

  /**
   * Function that hides/shows reservation room detail
   *
   * It also hides/shows selected lines
   *
   * @param {Element} e clicked button
   */
    showHideReservationDetail(e)
    {
        let lines = $(e)
        .parents(".reservation_reservation-detail-wrapper")
        .find("hr");

        if (e.classList.contains("active")) {
            e.classList.remove("active");
            $(e)
            .parents(".reservation_reservation-detail-wrapper")[0]
            .classList.remove("active");
            $(e).text($("#trans-show-more")[0].value);

            $(lines).each((i, e) => {
                if ($(e)[0].id !== "") {
                    $(e).css("display", "none");
                }
            });
        } else {
            e.classList.add("active");
            $(e)
            .parents(".reservation_reservation-detail-wrapper")[0]
            .classList.add("active");
            $(e).text($("#trans-show-less")[0].value);

            $(lines).each(function (i, e) {
                if ($(e)[0].id !== "") {
                    $(e).css("display", "block");
                }
            });
        }
    }

  /**
   * Function that removes room from cart in reservation module
   *
   * It also checks if there is more than one left
   *
   * It also changes full price value
   *
   * If only one is left the remove button is hidden
   *
   * @param {Element} e clicked element
   */
    removeRoom(e)
    {
        let roomID = $(e).data("roomid");
        let thisElement = $(e);

        $.ajax({
            headers: {
                "X-App-Locale": $('[name="country"]').attr("content"),
            },
            url: window.location.origin + "/api/delete/cart/room",
            method: "post",
            data: {
                room_id: roomID,
                _token: $('meta[name="csrf-token"]').attr("content"),
            },
            success: (data) => {
                if (data.result) {
                    let roomHTMLID = $(thisElement).data("remove");
                    $("[data-removewrapper='" + roomHTMLID + "']").remove();
                    let roomsLeft = $("[data-removewrapper]");
                    let totalPrice = $("#input-total-price");
                    let summaryRoomPrice = $("li[data-remove='" + roomHTMLID + "']").data(
                        "price"
                    );
                    let currency = $("#input-currency")[0].value;

                    $("[data-remove='" + roomHTMLID + "']").remove();

                    let newTotalPrice = (parseFloat(totalPrice[0].value) - parseFloat(summaryRoomPrice)).toFixed(2);
                    totalPrice.val(newTotalPrice);
                    newTotalPrice = Helper.thousandsSeparatorWithDot(newTotalPrice) + " " + currency;
                    let translation = roomsLeft.length > 1
                        ? $("#trans-rooms")[0].value
                        : $("#trans-room")[0].value;

                    $("#summary-total-price").text(newTotalPrice);
                    $("#count-rooms").text(roomsLeft.length + " " + translation);

                    if (roomsLeft.length == 1) {
                        $(".reservation_remove-room").css("display", "none");
                    }

                    if (
                        $("[data-removewrapper=" + this.removeWrapperCount + "]").length === 0
                    ) {
                        let moveWrapper = $("[data-movewrapper]").first();
                        this.removeWrapperCount = $(moveWrapper).data("removewrapper");
                        if ($(moveWrapper).length > 0) {
                            $(moveWrapper).removeClass("module");
                            $(moveWrapper).removeClass("mb-35");
                            $("[data-movetowrapper]").append($(moveWrapper));
                        }
                    }

                    let roomsLeftGuests = $("[data-guestwrapper]");

                    // reservation details part
                    $(roomsLeft).each((i, e) => {
                        $(e)
                            .find("[data-name]")
                            .text(i + 1 + "° " + $("#trans-room")[0].value);
                    });

                    // guest details part
                    $(roomsLeftGuests).each((i, e) => {
                        $(e)
                            .find("[data-name]")
                            .text(i + 1 + "° " + $("#trans-room")[0].value);
                    });

                    // bank card part
                    let cardRequired = $('[data-card-required="1"]').length > 0;

                    if (!cardRequired) {
                        $('[data-bank-card-module]').remove();
                    }
                }
            },
        });
    }

  /**
   * Function that changes required attribute for inputs - this function is needed because of responsive
   * version. Some modules are loaded multiple times and only hidden, but request sees them anyway
   * and do not know how to handle them.
   */
    static inputRequiredCheck()
    {
        if (window.innerWidth <= 1052) {
            $(".hide-under-1052 input:not('#checkbox-fill')").removeAttr("required");
            $(".hide-under-1052 select").removeAttr("required");
            $(".show-under-1052:not([data-showhideunder1052]) input:not('#checkbox-fill'):not([type='hidden'])").prop("required", true);
            $(".show-under-1052:not([data-showhideunder1052]) select").prop(
                "required",
                true
            );
        } else {
            $(".show-under-1052 input:not('#checkbox-fill')").removeAttr("required");
            $(".show-under-1052 select").removeAttr("required");
            $(
                ".hide-under-1052:not([data-showhideunder1052]) input:not('#checkbox-fill'):not([type='hidden'])"
            ).prop("required", true);
            $(".hide-under-1052:not([data-showhideunder1052]) select").prop(
                "required",
                true
            );
        }
    }

  /**
   * Function that removes filled data if user is logged
   *
   * @param {Element} element clicked element
   */
    removeFilledData(element)
    {
        let allInputs = $("[data-inputToClear]");
        $("button[name='complete_reservation']").addClass("disabled");

        if ($(element)[0].checked) {
            allInputs.each((i, e) => {
                $(e).val("");
            });
        } else {
            allInputs.each((i, e) => {
                if ($(e)[0].id.includes('contact_number')) {
                    let input = document.querySelector('#'+$(e)[0].id);
                    let iti = window.intlTelInputGlobals.getInstance(input);
                    iti.setNumber($(e).data('originalvalue'));
                } else {
                    $(e).val($(e).data('originalvalue'));
                }
            });
        }

        this.checkFilledInputs();
    }

  /**
   * Submits reservation form or shows not filled data
   *
   * @param {Element} e
   */
    submitForm(e)
    {
        let requiredInputs = $("#bookingForm").find("[required]");

        let first = true;

        $(requiredInputs).each((i, e) => {
            if (
                $(e).val() === "" ||
                $(e).val() == null ||
                !$(e)
                .val()
                .replace(/\s/g, "").length
            ) {
                $(e).addClass("error");

                if (first) {
                    Helper.scrollToElement(e, -100, 500);
                    first = false;
                }
            } else {
                $(e).removeClass("error");

                if ($(e)[0].name.includes("email")) {
                    if (!Helper.checkEmailCorrectness($(e).val())) {
                        if (first) {
                            Helper.scrollToElement(e, -100, 500);
                            first = false;
                        }

                        $(e).addClass("error");
                    }
                } else if ($(e)[0].name.includes("contact_number")) {
                    let regex = /^[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{3,6}$/im;
                    if (!regex.test($(e).val())) {
                        if (first) {
                            Helper.scrollToElement(e, -100, 500);
                            first = false;
                        }

                        $(e).addClass("error");
                    }
                }  else if ($(e)[0].name.includes("country")) {
                    if ($(e).val() === 0) {
                        if (first) {
                            Helper.scrollToElement(e, -100, 500);
                            first = false;
                        }
                        $(e).addClass("error");
                    }
                }
            }
        });

        if (first) {
            $(requiredInputs).removeClass("error");
        }

        let cardValid = cardCheck.checkCardValid();
        let expirationValid = cardCheck.checkExpirationValid();

        if (cardValid && expirationValid) {
            $("#bookingForm").submit();
        }
    }

  /**
   * Function that checks if all required inputs are filled
   */
    checkFilledInputs()
    {
        let requiredInputs = $("#bookingForm").find("[required]");
        let filled = true;

        $(requiredInputs).each((i, e) => {
            if (
                $(e).val() === "" ||
                $(e).val() === null ||
                !$(e)
                .val()
                .replace(/\s/g, "").length
            ) {
                filled = false;
                $(e).addClass("error");
            } else {
                $(e).removeClass("error");

                if ($(e)[0].name.includes("email")) {
                    if (!Helper.checkEmailCorrectness($(e).val())) {
                        filled = false;
                        $(e).addClass("error");
                    }
                } else if ($(e)[0].name.includes("contact_number")) {
                    let regex = /^[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{3,6}$/im;
                    if (!regex.test($(e).val())) {
                        filled = false;
                        $(e).addClass("error");
                    }
                } else if ($(e)[0].name.includes("country")) {
                    if (parseInt($(e).val()) === 0) {
                        filled = false;
                        $(e).addClass("error");
                    }
                }
            }
        });

        if (filled && this.radioButtonClicked) {
            $("button[name='complete_reservation']").removeClass("disabled");
        } else {
            $("button[name='complete_reservation']").addClass("disabled");
        }
    }

  /**
   * Function that enables inputs in confirmed reservation for editing
   *
   * @param {String} section
   */
    openEditInputs(section)
    {
        let inputs = $("[data-" + section + "]");

      // enable inputs
        $(inputs).each((i, e) => {
            $(e)[0].disabled = false;
        });

      // hide edit
        $("[data-" + section + "btn]").hide();

      // show cancel save
        $("[data-" + section + "show]").show();
    }

  /**
   * Function that shows edit text and hides cancel and save text/btn
   *
   * @param {String} section
   * @param {Boolean} save
   */
    cancelEditingReservationInfo(section, save = false)
    {
        let inputs = $("[data-" + section + "]");

        if (!save && section !== 'cardedit') {
            let input = document.querySelector("#phone_number");
            let iti = window.intlTelInputGlobals.getInstance(input);

            $(inputs).each((i, e) => {
                if ($(e)[0].id === 'phone_number') {
                    iti.setNumber($(e).data("originalvalue"));
                } else{
                    $(e).val($(e).data("originalvalue"));
                }

                $(e).removeClass("error");
            });

            let dialCode = $("#dial_code");
            $(dialCode).val($(dialCode).data("originalvalue"));
        } else if (section === 'cardedit') {
            $('input[data-cardedit]').each((i,e) => {
                $(e).val("");
            })

            $('[data-bank-icon-edit]').hide();
        }

      // disable inputs
        $(inputs).each((i, e) => {
            $(e)[0].disabled = true;
        });

      // show edit
        $("[data-" + section + "btn]").show();

      // hide cancel save
        $("[data-" + section + "show]").hide();
    }

  /**
   * Save reservation info edited
   *
   * @param {String} section
   */
    saveReservationInfo(section)
    {
        let inputs = $("[data-" + section + "]");
        let captchaInput = $('#recaptcha-token');
        let inputsVal = {};
        let canSave = true;

        if (section === "cardedit") {
            if (!cardCheck.checkCardValid()) {
                canSave = false;
            }

            if (!cardCheck.checkExpirationValid()) {
                canSave = false;
            }
        }

        $(inputs).each((i, e) => {
            if (!canSave) {
                return;
            }

            if (
            $(e)[0].name === "email" &&
            !Helper.checkEmailCorrectness($(e).val())
        ) {
            $(e).addClass("error");
            canSave = false;
            } else {
                if (
                $(e).val() === "" ||
                !$(e)
                .val()
                .replace(/\s/g, "").length
                ) {
                    $(e).addClass("error");
                    canSave = false;
                } else {
                    $(e).removeClass("error");

                    $(e).data("originalvalue", $(e).val());
                    inputsVal[$(e)[0].name] = $(e).val();
                }
            }
        });

        if (canSave) {
            $('[data-geuest-edit-recaptchaError]').hide();
            $('[data-bankcard-edit-recaptchaError]').hide();

            if (section === "guestedit") {
                let dialCode = $("#dial_code");

                $(dialCode).data("originalvalue", $(dialCode).val());
                inputsVal["dial_code"] = $(dialCode).val();
            }

            let timezoneOffsetMinutes = new Date().getTimezoneOffset();
            timezoneOffsetMinutes =
            timezoneOffsetMinutes == 0 ? 0 : -timezoneOffsetMinutes;

            // then saving functionality
            $.ajax({
                headers: {
                    "X-App-Locale": $('[name="country"]').attr("content"),
                },
                url: window.location.origin + "/reservation/edit/save",
                method: "post",
                data: {
                    inputs: inputsVal,
                    bookingID: $('input[name="booking_id"]').val(),
                    emailToken: $('input[name="emailToken"]').val(),
                    guestEdit: section === "guestedit" ? 1 : 0,
                    timezoneOffsetMinutes: timezoneOffsetMinutes,
                    _token: $('meta[name="csrf-token"]').attr("content"),
                    captcha: captchaInput.val(),
                },
                success: (data) => {
                    if (section === "cardedit") {
                        if (data.length > 0) {
                            let parsedData = JSON.parse(data);
                            if (parsedData['captchaError']) {
                                $('[data-bankcard-edit-recaptchaError]').show();
                                return;
                            }
                        }

                        let newCardValue = $('input[name="card_number"]').val();
                        let lastFourNumbers = newCardValue.substr(newCardValue.length - 4);
                        newCardValue = newCardValue.replace(/./g, "*");
                        newCardValue = newCardValue.substring(0, newCardValue.length - 4);

                        let newCardHashedValue = newCardValue + lastFourNumbers;
                        $("[data-cardnumberhashed]").val(newCardHashedValue);
                        this.cancelEditingReservationInfo(section, true);
                    } else {
                        if (data.length > 0) {
                            let parsedData = JSON.parse(data);
                            let phoneNumber = $('#phone_number');

                            if (parsedData['captchaError']) {
                                $('[data-geuest-edit-recaptchaError]').show();
                            } else if (parsedData['phone_error']) {
                                if (!$(phoneNumber).hasClass('error')) {
                                    $(phoneNumber).addClass('error');
                                }
                            } else {
                                if ($(phoneNumber).hasClass('error')) {
                                    $(phoneNumber).removeClass('error');
                                }

                                this.cancelEditingReservationInfo(section, true);
                            }
                        } else {
                            this.cancelEditingReservationInfo(section, true);
                        }
                    }
                    recaptcha((token) => {
                        captchaInput.val(token);
                    });
                }
            });
        } else {
            return;
        }

        recaptcha((token) => {
            captchaInput.val(token);
        });
    }

  /**
   * Function that sends email from modals
   *
   * @param {String} type
   */
    sendEmail(type)
    {
        let input = $('input[name="email_' + type + '"]');
        let captchInput = $('#reservation-status-recaptcha-token');

        if (Helper.checkEmailCorrectness(input.val())) {
            input.removeClass("error");
            $('[data-reservation-error-recaptchaError]').hide();

            // ajax call to send email
            $.ajax({
                headers: {
                    "X-App-Locale": $('[name="country"]').attr("content"),
                },
                url: window.location.origin + "/reservation/send-mail",
                method: "post",
                data: {
                    type: type,
                    email: input.val(),
                    bookingID: $('input[name="booking_id"]').val(),
                    _token: $('meta[name="csrf-token"]').attr("content"),
                    captcha: captchInput.val(),
                },
                success: (data) => {
                    let parsedData = JSON.parse(data);
                    if (parsedData['captchaError']) {
                        $('[data-reservation-error-recaptchaError]').show();
                        if (type == 'resend') {
                            $("[data-alertbefore]").first().html('');
                        } else {
                            $("[data-alertbefore-resend]").first().html('');
                        }
                        return;
                    }

                    if (parsedData['msg']) {
                        if (type == 'resend') {
                            $("[data-alertbefore]").first().html(parsedData['msg']);
                        } else {
                            $("[data-alertbefore-resend]").first().html(parsedData['msg']);
                        }
                    }

                    recaptcha((token) => {
                        captchInput.val(token);
                    })
                }
            });
        } else {
            // show red input
            input.addClass("error");
        }

        recaptcha((token) => {
            captchInput.val(token);
        })
    }

    /**
     * Handles click on dim after cancelling reservation
     *
     * @param {Element} dim
     */
    static handleDimClick(dim)
    {
        $(dim).removeClass('active');
        $('[data-reservationCancelled]').addClass('hidden-mvio');
        $('body').css('overflow', 'scroll');
    }
}
